import {React, useState, useEffect} from 'react';
import Hightcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

const PieChart = ({chartData, title, selectOpenData, setCommName, type}) => {
  if (chartData == undefined || chartData.length == 0) {
      return
  }

  const pieClick = (e) => {	
    setCommName(" [ "+e.point.name+" ]");
      selectOpenData(e.point.name, type);
  }

  //Pie chart
  const optionsPie = {
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: 'pie'
    },
    title: {
      text: title,
      style : {
        color : '#000',
        fontSize : "14px",
        fontWeight : "bold"
      }
    },
    tooltip: {
        pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
    },
    plotOptions: {  
      pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
              enabled: true,
              format: '<b>{point.name}</b>:{point.percentage:.1f}%',
              distance: 2,
          },
          events: {
            click: function(event) {
              pieClick(event);
            }
          }
      }
  },
    series: [{
      name: '분포도',
      data: chartData,
      size: 180
    }],
    accessibility: {
      enabled: false
    },
  };

  return (
    <>
      <HighchartsReact  highcharts = {Hightcharts} options = {optionsPie} containerProps={{ style: { width:'100%' ,height: "90%" } }} />
    </>
  );
};

export default PieChart;